import React from "react";
import { string } from "prop-types";

// import { Card, CardContent, Image, ButtonPrimary } from './../../../components';
import Card, { CardContent } from "../../../components/Card";
import Image from "../../../components/Image";
import { ButtonPrimary } from "../../../components/Button";

const propTypes = {
  imageSrc: string,
};

const ProductCard = ({ imageSrc, children }) => (
  <Card>
    <CardContent>
      <Image src={imageSrc} />
      {children}
      <ButtonPrimary>Kúpiť</ButtonPrimary>
    </CardContent>
  </Card>
);

ProductCard.propTypes = propTypes;
ProductCard.displayName = "ProductCard";

export default ProductCard;
